import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('hygraph'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.hygraph,
  logoPath: logos.hygraph
});
